import { fromJS } from 'immutable'

const cloneItem = (item) => fromJS(item).toJS()


export default cloneItem